var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"data-id":_vm.id,"draggable":"true"},on:{"dragenter":_vm.dragEnter,"dragleave":_vm.dragLeave,"dragover":_vm.dragOver,"dragstart":_vm.dragStart,"dragend":_vm.dragEnd,"drop":_vm.drop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }